import React, { useState } from 'react';
import {
  Header,
  Promo,
  Test,
  Footer,
  ForWhat,
  Technologies,
  Notification
} from '@components';
import { useMatchMedia } from '@utils';
import { breakpoints, links } from '@config';

const App: React.FC = () => {
  const [ showNotification, setShowNotification ] = useState(false);
  const match = useMatchMedia(breakpoints.pc);
  
  const openApp = () => {
    if (match) {
      window.open(links.app.href, links.app.target);
    } else {
      setShowNotification(true);
    }
  };
  
  const closeNotification = () => {
    setShowNotification(false);
  };
  
  return (
    <>
      <Header />
      <Promo handleClick={openApp} />
      <ForWhat />
      <Technologies />
      <Test handleClick={openApp} />
      <Footer />
      { showNotification && <Notification handleClick={closeNotification} /> }
    </>
  );
}

export default App;
